import styled, { css } from 'styled-components';
import Text from '@components/text';
import Image from '@components/image';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 4rem;
    align-items: center;
    width: 100%;
    background-color: ${theme.colors.light};
    padding: 4.5rem 0;
    border-radius: ${theme.borderRadius.large};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 3.5rem 0;
      row-gap: 3.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 3.5rem 0;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 2.5rem 0;
      row-gap: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
    }
  `}
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
`;

export const StyledHeading = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`;

export const StyledTextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    text-align: center;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 0.5rem;
    }
  `}
`;

export const PaddingWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    padding: 0 3rem;
    max-width: 60rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 0 2rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 0 1rem;
    }
  `}
`;

export const StyledGrid = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 3rem;
    width: 100%;
    max-width: 60rem;
    grid-template-columns: repeat(3, 1fr);

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 2rem;
      row-gap: 1.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      gap: 1rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;

export const StyledBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
    }
  `}
`;

export const StyledIconImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const StyledIcon = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 3.5rem;
    height: 3.5rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      max-width: 3.25rem;
      height: 3.25rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      max-width: 3rem;
      height: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      max-width: 3rem;
      height: 3rem;
    }
  `}
`;
